import API from "../../api/api";
import { authHeader } from "../../helpers/authHeader";

const state = () => ({
  testdrive: [],
  testDriveObj: null,
  loading: false,
});

const mutations = {
  getfetchtestDrives(state, payload) {
    state.testdrive = payload;
  },
  getTestDriveDetail(state, payload) {
    state.testDriveObj = payload;
  },
  editTestDrive(state, payload) {
    state.testDriveObj = payload;
  },
  setDetailInput: (state, e) => {
    let testDriveObj = state.testDriveObj;
    testDriveObj[e.target.name] = e.target.value;
    state.testDriveObj = testDriveObj;
  },
  isLoading(state, payload) {
    state.loading = payload;
  },
};

const actions = {
  async fetchtestDrive({ commit }) {
    await API.get("test-drive")
      .then((res) => {
        commit("getfetchtestDrives", res.data.data);
      })
      .catch((err) => {
        console.log("ERROR", err);
      });
  },

  async fetchTestDriveDetail({ commit }, payload) {
    commit("isLoading", true);
    await API.get(`test-drive-page/${payload}`)
      .then((res) => {
        commit("getTestDriveDetail", res.data.data);
        commit("isLoading", false);
      })
      .catch((err) => {
        console.log("ERROR", err);
        commit("isLoading", false);
      });
  },

  async put({ commit }, payload) {
    await API.put(`test-drive-page/1`, payload, {
      headers: authHeader(),
    })
      .then((res) => {
        if (res) {
          commit("editTestDrive", res.data.data);
        }
      })
      .catch((err) => {
        console.log("ERROR", err);
      });
  },

  updateInput({ commit }, e) {
    commit("setDetailInput", e);
  },
};

const getters = {
  testDriveObj: (state) => state.testDriveObj,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
